import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
  RouterProvider,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { BetSlipProvider } from "./context/BetSlipContext";
import { ThemeProvider } from "./context/ThemeContext";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import {
  ProtectedRoute,
  ProtectedRouteLogin,
} from "./component/ProctectedRoute";
import Register from "./Pages/Register";
import Casino from "./Pages/Casino";

import HomeSkyWeb from "./Pages/Sky/WebSky/Home";
import DetailWebSky from "./Pages/Sky/WebSky/Detail";
import Inplay from "./Pages/Sky/WebSky/Inplay";
import FavouriteSkyWeb from "./Pages/Sky/WebSky/FavouriteSky";
import LeagueVelki from "./Pages/Velkie/LeagueVelki";
import SkyIndex from "./Pages/Sky/Index";
import InPlay from "./Pages/Sky/InPlay";
import DetailSky from "./Pages/Sky/MatchDetail/DetailSky";
import FavouriteVelkie from "./Pages/Velkie/FavouriteVelkie";
import FavouriteSky from "./Pages/Sky/FavouriteSky";
import SportsNew from "./Pages/Sky/SportsNew";
import AccountSky from "./Pages/Sky/AccountSky";
import AccountWeb from "./Pages/Sky/Account/AccountWeb";
import MyBetsWeb from "./Pages/Sky/Account/MyBetsWeb";
import Activitylog from "./Pages/Sky/Account/Activitylog";
import AccountStatement from "./Pages/Sky/Account/AccountStatement";
import BalanceOverview from "./Pages/Sky/Account/BalanceOverview";
import CurrentBet from "./Pages/Velkie/Account/CurrentBet";
import Index from "./Pages/Velkie/Index";
import Detail from "./Pages/Velkie/MatchDetail/Detail";
import { isMobile } from "react-device-detect";
import Promotion from "./Pages/Promotion";
import Account from "./Pages/Account/Account";
import Bank from "./Pages/Bank";
import Rebate from "./Pages/Rebate";
import ChangePassword from "./Pages/Account/ChangePassword";
import Refer from "./Pages/Refer";
import Vip from "./Pages/Vip";
import Rewards from "./Pages/Rewards";
import ReferWeb from "./Pages/ReferWeb";
import AccountWebNew from "./Pages/AccountWebNew";
import Layout from "./Pages/Layout";
import History from "./Pages/Account/History";
import Spin from "./Pages/Spin";
import SpinWeb from "./Pages/SpinWeb";
import AffiliateLink from "./Pages/AffiliateLink";
import Afiliates from "./Pages/Afiliates";
import PaymentStatus from "./Pages/PaymentStatus";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <ThemeProvider>
          <AuthProvider>
            <BetSlipProvider>
              <Outlet />
            </BetSlipProvider>
          </AuthProvider>
        </ThemeProvider>
      }
    >
      {" "}
      <Route path="/luckywheel" element={isMobile ? <Spin /> : <SpinWeb />} />
      <Route path="/" element={<Home />} />{" "}
      <Route path="/casino" element={<Casino />} />{" "}
      <Route path="/casino/:type" element={<Casino />} />{" "}
      <Route path="/casino/:type/:key" element={<Casino />} />{" "}
      <Route
        path="/rebate"
        element={
          isMobile ? (
            <Rebate />
          ) : (
            <ProtectedRouteLogin>
              <AccountWebNew />
            </ProtectedRouteLogin>
          )
        }
      />{" "}
      <Route
        path="/voucher"
        element={
          <ProtectedRouteLogin>
            <AccountWebNew />
          </ProtectedRouteLogin>
        }
      />{" "}
      {!isMobile && (
        <Route
          path="/profile"
          element={
            <ProtectedRouteLogin>
              <AccountWebNew />
            </ProtectedRouteLogin>
          }
        />
      )}
      {!isMobile && (
        <Route
          path="/betting-history"
          element={
            <ProtectedRouteLogin>
              <AccountWebNew />
            </ProtectedRouteLogin>
          }
        />
      )}
      <Route path="/refer" element={isMobile ? <Refer /> : <ReferWeb />} />{" "}
      <Route path="/vip" element={<Vip />} />{" "}
      <Route
        path="/reward"
        element={
          isMobile ? (
            <Rewards />
          ) : (
            <ProtectedRouteLogin>
              <AccountWebNew />
            </ProtectedRouteLogin>
          )
        }
      />{" "}
      <Route
        path="/login"
        element={
          <ProtectedRoute>
            <Login />
          </ProtectedRoute>
        }
      />
      <Route
        path="/register"
        element={
          <ProtectedRoute>
            <Register />
          </ProtectedRoute>
        }
      />{" "}
      <Route
        path="/account"
        element={
          <ProtectedRouteLogin>
            <Account />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/change-password"
        element={
          <ProtectedRouteLogin>
            {isMobile ? (
              <Layout>
                <div className={"profileLayout-padding margin-desktop"}>
                  <div className={"row mobile-full-height no-gutters"}>
                    <ChangePassword />
                  </div>
                </div>
              </Layout>
            ) : (
              <AccountWebNew />
            )}
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/bank/:type"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <Bank /> : <AccountWebNew />}
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/bank/:type/:offerCode"
        element={
          <ProtectedRouteLogin>
            <Bank />
          </ProtectedRouteLogin>
        }
      />{" "}
      {isMobile && (
        <Route
          path="/history/:type"
          element={
            <ProtectedRouteLogin>
              <History />
            </ProtectedRouteLogin>
          }
        />
      )}{" "}
    
       <Route path="/affiliateLink" element={<AffiliateLink />} />{" "}
        <Route path="/affilates" element={<Afiliates />} />

      <Route path="/promotion" element={<Promotion />} />{" "}
      <Route
        path="/exchange-velki/current-bet"
        element={
          <ProtectedRouteLogin>
            <CurrentBet />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/exchange/profile"
        element={
          <ProtectedRouteLogin>
            <AccountWeb />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/exchange/my-bets"
        element={
          <ProtectedRouteLogin>
            <MyBetsWeb />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/exchange/profit-loss"
        element={
          <ProtectedRouteLogin>
            <MyBetsWeb />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/exchange/activity-log"
        element={
          <ProtectedRouteLogin>
            <Activitylog />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/exchange/account-statement"
        element={
          <ProtectedRouteLogin>
            <AccountStatement />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/exchange/balance-overview"
        element={
          <ProtectedRouteLogin>
            <BalanceOverview />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/sports-velki"
        element={
          <ProtectedRouteLogin>
            <Index />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/sports-sky"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <SkyIndex /> : <HomeSkyWeb />}
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/sports-sky/:type"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <SkyIndex /> : <HomeSkyWeb />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/sports-sky-new"
        element={
          <ProtectedRouteLogin>
            <SportsNew />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/account-sky"
        element={
          <ProtectedRouteLogin>
            <AccountSky />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/favourite-velkie"
        element={
          <ProtectedRouteLogin>
            <FavouriteVelkie />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/favourite-sky"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <FavouriteSky /> : <FavouriteSkyWeb />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/inplay-sky"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <InPlay /> : <Inplay />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/league-velki"
        element={
          <ProtectedRouteLogin>
            <LeagueVelki />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-sky/:eventId/:marketId"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <DetailSky /> : <DetailWebSky />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-sky/:eventId/:marketId/:type"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <DetailSky /> : <DetailWebSky />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-velki/:eventId/:marketId"
        element={
          <ProtectedRouteLogin>
            <Detail />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-velki/:eventId/:marketId/:type"
        element={
          <ProtectedRouteLogin>
            <Detail />
          </ProtectedRouteLogin>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
      <Route path="/proceed" element={<PaymentStatus />} />
    </Route>,
  ),
);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
